import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Switch, useLocation } from "react-router-dom";
import Inicio from "./components/Inicio/Inicio";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Tramites from "./components/Tramites/Tramites";
import Transparencia from "./components/Transparencia/Transparencia";
import Organismos from "./components/Organismos/Organismos";
import Informacion from "./components/Informacion/Informacion";
import RubrosSesa from "./components/RubrosSesa/RubrosSesa";
import RubrosSsh from "./components/RubrosSsh/RubrosSsh";
import Licitaciones2026 from "./components/Transparencia/LicitacionesEstatales/Licitaciones2026";
import Licitaciones2025 from "./components/Transparencia/LicitacionesEstatales/Licitaciones2025";
import Licitaciones2024 from "./components/Transparencia/LicitacionesEstatales/Licitaciones2024";
import Licitaciones2023 from "./components/Transparencia/LicitacionesEstatales/Licitaciones2023";
import Licitaciones2022 from "./components/Transparencia/LicitacionesEstatales/Licitaciones2022";
import Licitaciones2021 from "./components/Transparencia/LicitacionesEstatales/Licitaciones2021";
import Licitaciones2020 from "./components/Transparencia/LicitacionesEstatales/Licitaciones2020";
import Licitacionesf2024 from "./components/Transparencia/LicitacionesFederales/Licitacionesf2024";
import Licitacionesf2023 from "./components/Transparencia/LicitacionesFederales/Licitacionesf2023";
import Licitacionesf2022 from "./components/Transparencia/LicitacionesFederales/Licitacionesf2022";
import Conac from "./components/Transparencia/Conac/Conac";
import DetalleRubroSesa from "./components/DetalleRubroSesa/DetalleRubroSesa";
import DetalleRubroSsh from "./components/DetalleRubroSsh/DetalleRubroSsh";
import RubrosHistoricosSesa from "./components/RubrosHistoricosSesa/RubrosHistoricosSesa";
import RubrosHistoricosSsh from "./components/RubrosHistoricosSsh/RubrosHistoricosSsh";
import Agenda from "./components/Agenda/Agenda";
import Publicaciones from "./components/Informacion/Publicaciones/Publicaciones";
import Comparecencias from "./components/Informacion/Publicaciones/Comparecencias/Comparecencias";
import DiarioOficial from "./components/Informacion/Publicaciones/DOFPOEH/DofPoeh";
import Poblacion from "./components/Informacion/Publicaciones/poblaResponsabilidad/poblaResponsabilidad";
import PoblacionMun from "./components/Informacion/Publicaciones/poblaMunicipio/poblaMunicipio";
import ArchivisticoSESA from "./components/Informacion/Publicaciones/IRPADArchivisticoSESA/IRPADArchivisticoSESA";
import ArchivisticoSSH from "./components/Informacion/Publicaciones/IRPADArchivisticoSSH/IRPADArchivisticoSSH";
import PADArchivisticoSESA from "./components/Informacion/Publicaciones/PADArchivisticoSESA/PADArchivisticoSESA";
import PADArchivisticoSSH from "./components/Informacion/Publicaciones/PADArchivisticoSSH/PADArchivisticoSSH";
import Anexo from "./components/Informacion/Publicaciones/Anexo7CAF/Anexo7CAF";
import Pss from "./components/Informacion/Publicaciones/Pss/Pss";
import Pid from "./components/Informacion/Publicaciones/Pid/Pid";
import Gaceta from "./components/Informacion/Gaceta/Gaceta";
import Error404 from "./components/Error404/Error404";
import Conoce from "./components/Informacion/Conoce/Conoce";
import Clues from "./components/Informacion/CLUES/clues";
import JurHidalgo from "./components/Informacion/Jurisdicciones/Jurisdicciones";
import MarcoOpssh from "./components/Informacion/MarcoOpSsh/MarcoOpssh";
import MarcoOpSesa from "./components/Informacion/MarcoOpSesa/MarcoOpSesa";
import Lesp from "./components/Organismos/Lesp/Lesp";
import Cets from "./components/Organismos/Cets/Cets";
import Aps from "./components/Organismos/Aps/Aps";
import Cetra from "./components/Organismos/Cetra/Cetra";
import Donadornt from "./components/Organismos/Cetra/Donadornt/Donadornt";
import TransplanteP from "./components/Organismos/Cetra/TransplanteP/TransplanteP";
import TransFaq from "./components/Organismos/Cetra/TransFaq/TransFaq";
import GastosCovid from "./components/Transparencia/GastosCovid/GastosCovid";
import GastoSalud from "./components/Transparencia/GastoSalud/GastoSalud";
import Armonizacion from "./components/Transparencia/Armonizacion/Armonizacion";
import Convenios from "./components/Transparencia/Convenios/Convenios";
import Saf from "./components/Transparencia/Saf/Saf";
import Sps from "./components/Transparencia/Sps/Sps";
import PaaasSesa from "./components/Transparencia/PaaasSesa/PaaasSesa";
import PaopsrSsh from "./components/Transparencia/PaopsrSsh/PaopsrSsh";
import MejoraRegulatoria from "./components/Transparencia/MejoraRegulatoria/MejoraRegulatoria";
import PaaasSsh from "./components/Transparencia/PaaasSsh/PaaasSsh";
import ProtocoloCero from "./components/ProtocoloCero/ProtocoloCero";
import Pcam from "./components/Transparencia/Convenios/Pcam/Pcam";
import Insabiconv from "./components/Transparencia/Convenios/Insabiconv/Insabiconv";
import Apsas from "./components/Transparencia/Apsas/Apsas";
import Epidemiologico2024 from "./components/Transparencia/Epidemiologico/Epidemiologico2024";
import Epidemiologico2025 from "./components/Transparencia/Epidemiologico/Epidemiologico2025";
import Boletines2025 from "./components/Transparencia/Epidemiologico/EpidemiologicoBoletines2025";
import Boletines2026 from "./components/Transparencia/Epidemiologico/EpidemiologicoBoletines2026";
import DAN2025 from "./components/Transparencia/Epidemiologico/Boletines2025/DAN";
import IAAS2025 from "./components/Transparencia/Epidemiologico/Boletines2025/IAAS";
import IAAS2026 from "./components/Transparencia/Epidemiologico/Boletines2026/IAAS";
import MMEG2025 from "./components/Transparencia/Epidemiologico/Boletines2025/MMEG";
import Arbovirosis2025 from "./components/Transparencia/Epidemiologico/Boletines2025/Arbovirosis";
import Monitoreo2025 from "./components/Transparencia/Epidemiologico/Boletines2025/Monitoreo";
import ImssBienestar from "./components/Transparencia/Convenios/ImssBienestar/ImssBienestar";
import DirPersonalSESA from "./components/Transparencia/DirPersonal/DirPersonalSESA";
import DirPersonalSSH from "./components/Transparencia/DirPersonal/DirPersonalSSH";
import CodigoQR from "./components/Infografias/CodigoQR/CodigoQR";
import ReactGA from 'react-ga4'

ReactGA.initialize("G-XSM2QXL6V6");

const PageViewTracker = () => {
  const location = useLocation()

  useEffect(() => {
    ReactGA.send('pageview')
  }, [location])

  return <></>
}


function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route exact path="/" element={<Inicio />} />
        <Route exact path="/Tramites" element={<Tramites />} />
        <Route exact path="/Transparencia" element={<Transparencia />} />
        <Route exact path="/Organismos" element={<Organismos />} />
        <Route exact path="/Informacion" element={<Informacion />} />
        <Route
          exact
          path="/Transparencia/RubrosSesa"
          element={<RubrosSesa />}
        />
        <Route exact path="/Transparencia/RubrosSsh" element={<RubrosSsh />} />
        <Route
          exact
          path="/Transparencia/RubrosSesa/DetalleRubroSesa/:nombre"
          element={<DetalleRubroSesa />}
        />
        <Route
          exact
          path="/Transparencia/RubrosSesa/RubrosHistoricosSesa"
          element={<RubrosHistoricosSesa />}
        />
         <Route
          exact
          path="/Transparencia/RubrosSsh"
          element={<RubrosSsh />}
        />
        <Route exact path="/Transparencia/RubrosSsh" element={<RubrosSsh />} />
        <Route
          exact
          path="/Transparencia/RubrosSsh/DetalleRubroSsh/:nombre"
          element={<DetalleRubroSsh />}
        />
        <Route
          exact
          path="/Transparencia/RubrosSsh/RubrosHistoricosSsh"
          element={<RubrosHistoricosSsh />}
        />
        <Route
          exact
          path="/Informacion/Conoce"
          element={<Conoce />}
        />
        <Route
          exact
          path="/Informacion/CLUES"
          element={<Clues />}
        />
        <Route
          exact
          path="/Informacion/Jurisdicciones"
          element={<JurHidalgo />}
        />
        <Route
          exact
          path="/Informacion/MarcoOpSsh"
          element={<MarcoOpssh />}
        />
        <Route
          exact
          path="/Transparencia/LicitacionesEstatales/Licitaciones2026"
          element={<Licitaciones2026 />}
        />
        <Route
          exact
          path="/Transparencia/LicitacionesEstatales/Licitaciones2025"
          element={<Licitaciones2025 />}
        />
        <Route
          exact
          path="/Transparencia/LicitacionesEstatales/Licitaciones2024"
          element={<Licitaciones2024 />}
        />
        <Route
          exact
          path="/Transparencia/LicitacionesEstatales/Licitaciones2023"
          element={<Licitaciones2023 />}
        />
        <Route
          exact
          path="/Transparencia/LicitacionesEstatales/Licitaciones2022"
          element={<Licitaciones2022 />}
        />
        <Route
          exact
          path="/Transparencia/LicitacionesEstatales/Licitaciones2021"
          element={<Licitaciones2021 />}
        />
         <Route
          exact
          path="/Transparencia/LicitacionesEstatales/Licitaciones2020"
          element={<Licitaciones2020 />}
        />
        <Route
          exact
          path="/Transparencia/LicitacionesFederales/Licitacionesf2024"
          element={<Licitacionesf2024 />}
        />
        <Route
          exact
          path="/Transparencia/LicitacionesFederales/Licitacionesf2023"
          element={<Licitacionesf2023 />}
        />
        <Route
          exact
          path="/Transparencia/LicitacionesFederales/Licitacionesf2022"
          element={<Licitacionesf2022 />}
        />
         <Route
          exact
          path="/Transparencia/Conac/Conac"
          element={<Conac />}
        />
        <Route
          exact
          path="/Informacion/Publicaciones"
          element={<Publicaciones />}
        />
        <Route
          exact
          path="/Informacion/Publicaciones/Comparecencias/Comparecencias"
          element={<Comparecencias />}

        />
        <Route
          exact
          path="/Informacion/Publicaciones/poblaResponsabilidad/poblaResponsabilidad"
          element={<Poblacion />}

        />
        <Route
          exact
          path="/Informacion/Publicaciones/poblaMunicipio/poblaMunicipio"
          element={<PoblacionMun />}

        />
        <Route
          exact
          path="/Informacion/Publicaciones/IRPADArchivisticoSESA/IRPADArchivisticoSESA"
          element={<ArchivisticoSESA />}

        />
        <Route
          exact
          path="/Informacion/Publicaciones/IRPADArchivisticoSSH/IRPADArchivisticoSSH"
          element={<ArchivisticoSSH />}

        />
        <Route
          exact
          path="/Informacion/Publicaciones/PADArchivisticoSESA/PADArchivisticoSESA"
          element={<PADArchivisticoSESA />}

        />
        <Route
          exact
          path="/Informacion/Publicaciones/PADArchivisticoSSH/PADArchivisticoSSH"
          element={<PADArchivisticoSSH />}

        />
        <Route
          exact
          path="/Informacion/Publicaciones/Anexo7CAF/Anexo7CAF"
          element={<Anexo />}

        />
        <Route
        exact
        path="/Informacion/Publicaciones/Comparecencias/Pss"
        element={<Pss />}

      />
      <Route
        exact
        path="/Informacion/Publicaciones/DOFPOEH/DofPoeh"
        element={<DiarioOficial />}
      />
      <Route
        exact
        path="/Informacion/Publicaciones/Comparecencias/Pid"
        element={<Pid />}

      />
      
        <Route
          exact
          path="/Informacion/Gaceta/Gaceta"
          element={<Gaceta />}
        />
        <Route
          exact
          path="/Informacion/MarcoOpSesa/MarcoOpSesa"
          element={<MarcoOpSesa />}
        />
        <Route
          exact
          path="/Organismos/Lesp/Lesp"
          element={<Lesp />}
        />
        <Route
          exact
          path="/Organismos/Cets/Cets"
          element={<Cets />}
        />
        <Route
          exact
          path="/Organismos/Aps/Aps"
          element={<Aps />}
        />
        <Route
          exact
          path="/Organismos/Cetra/Cetra"
          element={<Cetra />}
        />
        <Route
          exact
          path="/Organismos/Cetra/Donadornt/Donadornt"
          element={<Donadornt />}
        />
        <Route
          exact
          path="/Organismos/Cetra/TransplanteP/TransplanteP"
          element={<TransplanteP />}
        />
        <Route
          exact
          path="/Organismos/Cetra/TransFaq/TransFaq"
          element={<TransFaq />}
        />
        <Route
          exact
          path="Transparencia/GastosCovid/GastosCovid"
          element={<GastosCovid />}
        />
        <Route
          exact
          path="/Transparencia/Armonizacion/Armonizacion"
          element={<Armonizacion />}
        />
        <Route
          exact
          path="/Transparencia/Convenios/Convenios"
          element={<Convenios />}
        />
        <Route
          exact
          path="/Transparencia/Saf/Saf"
          element={<Saf />}
        />
        <Route
          exact
          path="/Transparencia/Sps/Sps"
          element={<Sps />}
        />
         <Route
          exact
          path="/Transparencia/PaaasSesa/PaaasSesa"
          element={<PaaasSesa />}
        />
         <Route
          exact
          path="/Transparencia/PaopsrSsh/PaopsrSsh"
          element={<PaopsrSsh />}
        />
        <Route
          exact
          path="/Transparencia/MejoraRegulatoria/MejoraRegulatoria"
          element={<MejoraRegulatoria />}
        />
        <Route
          exact
          path="/Transparencia/PaaasSsh/PaaasSsh"
          element={<PaaasSsh />}
        />
        <Route exact path="/Agenda" element={<Agenda />} />
        <Route exact path="*" element={<Error404 />} />
        <Route
          exact
          path="/Transparencia/GastoSalud"
          element={<GastoSalud />}
        />
         <Route
          exact
          path="/ProcoloCero/ProtocoloCero"
          element={<ProtocoloCero />}
        />
        <Route
          exact
          path="/Transparencia/Convenios/Pcam/Pcam"
          element={<Pcam />}
        />
        <Route
          exact
          path="/Transparencia/Convenios/Insabiconv/Insabiconv"
          element={<Insabiconv />}
        />
        <Route
          exact
          path="/Transparencia/Apsas/Apsas"
          element={<Apsas />}
        />
        <Route
          exact
          path="/Transparencia/Epidemiologico/Epidemiologico2024"
          element={<Epidemiologico2024 />}
        />
        <Route
          exact
          path="/Transparencia/Epidemiologico/Epidemiologico2025"
          element={<Epidemiologico2025 />}
        />
        <Route
          exact
          path="/Transparencia/Epidemiologico/Boletines2025"
          element={<Boletines2025 />}
        />
        <Route
          exact
          path="/Transparencia/Epidemiologico/Boletines2026"
          element={<Boletines2026 />}
        />
        <Route
          exact
          path="/Transparencia/Epidemiologico/Boletines2025/DAN"
          element={<DAN2025 />}
        />
        <Route
          exact
          path="/Transparencia/Epidemiologico/Boletines2025/IAAS"
          element={<IAAS2025 />}
        />
        <Route
          exact
          path="/Transparencia/Epidemiologico/Boletines2026/IAAS"
          element={<IAAS2026 />}
        />
        <Route
          exact
          path="/Transparencia/Epidemiologico/Boletines2025/MMEG"
          element={<MMEG2025 />}
        />
        <Route
          exact
          path="/Transparencia/Epidemiologico/Boletines2025/Arbovirosis"
          element={<Arbovirosis2025 />}
        />
        <Route
          exact
          path="/Transparencia/Epidemiologico/Boletines2025/Monitoreo"
          element={<Monitoreo2025 />}
        />
        <Route
          exact
          path="/Transparencia/Convenios/ImssBienestar/ImssBienestar"
          element={<ImssBienestar />}
        />
         <Route
          exact
          path="/Transparencia/DirectorioSESA"
          element={<DirPersonalSESA />}
        />
        <Route
          exact
          path="/Transparencia/DirectorioSSH"
          element={<DirPersonalSSH />}
        />
        <Route
          exact
          path="/CodigoQR"
          element={<CodigoQR />}
        />
      </Routes>
      
      <Footer />
    </BrowserRouter>
  );
}

export default App;